import { PeriodTrendMap, AnalyticsPeriod } from './analytics.types';

export const ANALYTICS_PERIOD_OPTIONS: AnalyticsPeriod[] = [
  'This Week',
  'This Month',
  'This Term',
  'All Time',
  'Custom Range'
];

// Period-on-period trend deltas keyed by metric. Used by KPI cards
// across every tab. Backend will eventually replace this with a real
// `/analytics/trends?period=...` response.
export const ANALYTICS_PERIOD_TRENDS: PeriodTrendMap = {
  'This Week': {
    myTangrams:         { delta: 0,  unit: '' },
    mediaItems:         { delta: 1,  unit: '' },
    students:           { delta: 3,  unit: '' },
    engagementRate:     { delta: 5,  unit: '%' },
    totalInteractions:  { delta: 8,  unit: '' },
    views:              { delta: 14, unit: '' },
    uniqueUsers:        { delta: 5,  unit: '' },
    completionRate:     { delta: 3,  unit: '%' },
    avgTimeSpent:       { delta: -1, unit: 'm' },
    activeStudents:     { delta: 4,  unit: '%' },
    avgCompletion:      { delta: 2,  unit: '%' },
    avgTimeTangram:     { delta: -2, unit: 'm' },
    avgTimeContent:     { delta: 1,  unit: 'm' },
    comments:           { delta: 3,  unit: '' },
    pollCompletion:     { delta: 5,  unit: '%' },
    questionCompletion: { delta: 2,  unit: '%' }
  },
  'This Month': {
    myTangrams:         { delta: 2,  unit: '' },
    mediaItems:         { delta: 2,  unit: '' },
    students:           { delta: 7,  unit: '' },
    engagementRate:     { delta: 8,  unit: '%' },
    totalInteractions:  { delta: 18, unit: '' },
    views:              { delta: 42, unit: '' },
    uniqueUsers:        { delta: 18, unit: '' },
    completionRate:     { delta: 6,  unit: '%' },
    avgTimeSpent:       { delta: 3,  unit: 'm' },
    activeStudents:     { delta: 9,  unit: '%' },
    avgCompletion:      { delta: 5,  unit: '%' },
    avgTimeTangram:     { delta: 4,  unit: 'm' },
    avgTimeContent:     { delta: -1, unit: 'm' },
    comments:           { delta: 6,  unit: '' },
    pollCompletion:     { delta: 8,  unit: '%' },
    questionCompletion: { delta: -3, unit: '%' }
  },
  'This Term': {
    myTangrams:         { delta: 3,   unit: '' },
    mediaItems:         { delta: 6,   unit: '' },
    students:           { delta: 24,  unit: '' },
    engagementRate:     { delta: 12,  unit: '%' },
    totalInteractions:  { delta: 64,  unit: '' },
    views:              { delta: 183, unit: '' },
    uniqueUsers:        { delta: 56,  unit: '' },
    completionRate:     { delta: 11,  unit: '%' },
    avgTimeSpent:       { delta: 7,   unit: 'm' },
    activeStudents:     { delta: 18,  unit: '%' },
    avgCompletion:      { delta: 14,  unit: '%' },
    avgTimeTangram:     { delta: 9,   unit: 'm' },
    avgTimeContent:     { delta: 3,   unit: 'm' },
    comments:           { delta: 18,  unit: '' },
    pollCompletion:     { delta: 14,  unit: '%' },
    questionCompletion: { delta: 11,  unit: '%' }
  },
  'All Time': {
    myTangrams:         { delta: 7,   unit: '' },
    mediaItems:         { delta: 12,  unit: '' },
    students:           { delta: -5,  unit: '' },
    engagementRate:     { delta: -3,  unit: '%' },
    totalInteractions:  { delta: 127, unit: '' },
    views:              { delta: 412, unit: '' },
    uniqueUsers:        { delta: 98,  unit: '' },
    completionRate:     { delta: -4,  unit: '%' },
    avgTimeSpent:       { delta: 12,  unit: 'm' },
    activeStudents:     { delta: -6,  unit: '%' },
    avgCompletion:      { delta: -8,  unit: '%' },
    avgTimeTangram:     { delta: 14,  unit: 'm' },
    avgTimeContent:     { delta: 5,   unit: 'm' },
    comments:           { delta: 31,  unit: '' },
    pollCompletion:     { delta: -5,  unit: '%' },
    questionCompletion: { delta: 22,  unit: '%' }
  }
};

export const PAGE_SIZE = 5;
export const EXPORT_FORMATS = ['CSV', 'PDF', 'Excel'] as const;
export type ExportFormat = typeof EXPORT_FORMATS[number];
